var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCursos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.224,
    height: 71.714,
    viewBox: "0 0 51.224 71.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ya{fill:#ffeb00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ya",
    d: "M54.663,2H8.561A2.561,2.561,0,0,0,6,4.561V63.469A10.245,10.245,0,0,0,16.245,73.714H52.1a2.561,2.561,0,0,0,1.409-4.687,3.586,3.586,0,0,1-1.588-3,3.534,3.534,0,0,1,1.1-2.561h1.639a2.561,2.561,0,0,0,2.561-2.561V4.561A2.561,2.561,0,0,0,54.663,2ZM52.1,58.347H21.367V7.122H52.1ZM11.122,7.122h5.122V58.347H11.122ZM47.184,68.592H16.245a5.122,5.122,0,0,1-5.122-5.122H47.184A8.734,8.734,0,0,0,47.184,68.592ZM29.051,27.612H44.418a2.561,2.561,0,0,0,2.561-2.561V14.806a2.561,2.561,0,0,0-2.561-2.561H29.051a2.561,2.561,0,0,0-2.561,2.561V25.051A2.561,2.561,0,0,0,29.051,27.612Zm2.561-10.245H41.857V22.49H31.612Z",
    transform: "translate(-6 -2)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursos);
export default __webpack_public_path__ + "static/media/cursos.5e984a83.svg";
export { ForwardRef as ReactComponent };